import API from "../../../../../Services/API";
import { ENDPOINTS } from "utils/endpoints";
import {
  FETCH_CORRECTIBLE_BEGIN,
  FETCH_CORRECTIBLE_SUCCESS,
  FETCH_CORRECTIBLE_FAILURE
} from "./types";
import { GENERIC_ERROR_MESSAGE } from "../../DownloadAndDelete/actions/types";

export const fetchCorrectibleFormer = (cardId, selectedFormerAccount) => async dispatch => {
  dispatch({ type: FETCH_CORRECTIBLE_BEGIN });

  
  try {

    let serviceType = "";
    if(selectedFormerAccount.indicator === "WLS") {
      serviceType = "vzw-former"
    }
    else if(selectedFormerAccount.indicator === "WLN") {
      serviceType = "vzt-former"
    }
    else {
      serviceType = "vzw-former"
    }
    
    const data = {
      serviceType,
      accountId: selectedFormerAccount.billingAccountNumber
    }

    const response = await API({
      method: "POST",
      url: `${ENDPOINTS.FORMER_CORRECTIBLE}/${cardId}`,
      data
    });

    if (response && response.data && response.data.subcategoryData) {
      dispatch({
        type: FETCH_CORRECTIBLE_SUCCESS,
        payload: response.data.subcategoryData
      });
    } else {
      dispatch({ type: FETCH_CORRECTIBLE_FAILURE, payload: GENERIC_ERROR_MESSAGE });
    }
  } catch (error) {
    dispatch({ type: FETCH_CORRECTIBLE_FAILURE, payload: error.response.description });
  }
};
